<template>
  <div v-if="show" class="row">
    <div class="col">
      <spinner v-if="busy" />
      <div v-else class="row">
        <div v-for="(invoice, index) in invoices" :key="invoice.id" class="col col-12 col-md-8 m-md-auto">
          <b-card class="mb-3 py-3 px-2 px-sm-4 rounded bg-white border shadow fadein-details">
            <h2 class="text-center">
              {{ $t('Invoice:', {code: invoice.code}) }}
            </h2>
            <div class="col">
              <div class="row">
                <div class="col invoice" :class="{'col-9': (invoice.status === 'unpaid')}">
                  <div class="row">
                    <div class="col">
                      <div class="invoice__text">
                        {{ $t('Payment') }}:
                      </div>
                      <div class="invoice__description font-weight-500">
                        {{ invoice | invoicePayment }}
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div class="invoice__text">
                        {{ $t('Date:') }}
                      </div>
                      <div class="invoice__description font-weight-500">
                        {{ invoice.created_date | parseDate }}
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div class="invoice__text">
                        {{ $t('Description:') }}
                      </div>
                      <div class="invoice__description font-weight-500">
                        {{ invoice.description }}
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div class="invoice__text">
                        {{ $t('Total:') }}
                      </div>
                      <div class="invoice__description font-weight-500">
                        {{ $n(invoice.price_including_vat, 'currency') }}
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="invoice && canSettle(invoice)" class="col">
                  <b-checkbox class="float-right" :checked="invoice.select" size="lg" @change="rowSelected(index)" />
                </div>
              </div>

              <div v-if="!hasInvoicesSelected" class="row align-items-center mt-3 text-center">
                <div v-if="invoice.lead_code !== null" class="col">
                  <b-button variant="outline-secondary" size="sm" :to="{name: 'my-lead', params: {code: invoice.lead_code}}">
                    {{ $t('View Lead') }}
                  </b-button>
                </div>
                <div class="col px-0">
                  <b-button variant="outline-secondary" size="sm" :href="`${downloadUrl}invoice/${invoice.code}`">
                    <font-awesome-icon icon="download" />
                    <span class="d-sm-inline">{{ $t('PDF') }}</span>
                  </b-button>
                </div>
                <div v-if="invoice && canSettle(invoice)" class="col">
                  <b-button variant="primary" size="sm" @click="payRow(index)">
                    <span class="d-sm-inline">{{ $t('Pay Now') }}</span>
                  </b-button>
                </div>
              </div>
            </div>
          </b-card>
        </div>
        <div class="col col-12 mt-3">
          <b-pagination v-model="page" :total-rows="items" :per-page="pageSize" aria-controls="my-leads-table" align="right" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Spinner from "@/components/animation/Spinner";
import invoiceList from "@/imports/mixins/invoiceList";
import { captureError } from "@/services/userMonitoring";

export default {
  components: {Spinner},
  mixins: [invoiceList],
  props: ['show', 'sort', 'hasInvoicesSelected'],
  data() {
    return {
      busy: false,
      page: 1,
      items: 0,
      pageSize: 10,
      invoices: [],
      cachedInvoices: []
    }
  },
  computed: {
    downloadUrl: function() {
      return process.env.VUE_APP_DOWNLOAD_URL
    },
  },
  methods: {
    loadInvoices: async function() {
      try {
        this.busy = true;
        let result = await this.$api.invoices.list({page: this.page, sort: 'created_date-desc'});
        this.setMeta(result.data.meta);
        this.invoices = result.data.data.map((invoice) => ({...invoice, select: this.cachedInvoices.find(el => el.id === invoice.id) !== undefined, view: false}));
        this.busy = false;
        this.$emit('invoices-loaded');
      } catch (e) {
        captureError(e, {
          section: "invoices",
          action: "load-invoices",
          type: "api-request"
        });
      }
    },
    payRow(index) {
      this.rowSelected(index, true);
      this.$emit('show-payment');
    },
    deselectAll: function() {
      this.setAll(false);
    },
  },
}
</script>

<style scoped lang="scss">

.invoice {
  @media only screen and (max-width: 374px) {
    flex: 0 0 100%;
    max-width: 100%;
  }
  &__text {
    @include media-breakpoint-down(sm) {
      width: 80px;
    }
    @include media-breakpoint-between(md, lg) {
      width: 90px;
    }
    margin-right: 15px;
    float: left;
  }

  &__description {
    @include media-breakpoint-down(sm) {
      width: calc(100% - 105px);
    }
    @include media-breakpoint-between(md, lg) {
      width: calc(100% - 110px);
    }
    float: left;
  }
}

</style>
